import { useState } from 'react';
import { isBrowser } from 'utils';

/**
 * Tracks PayPal SDK readiness for a component that owns a <Script src={PAYPAL_EXPRESS_SDK}>.
 *
 * Initialises from window.paypal to handle remounts — next/script deduplicates by src,
 * so onLoad does not fire again if the SDK was already loaded on a previous mount.
 *
 * @param enabled - Whether the SDK should be loaded (hasPaypalExpress && totalGross > 0).
 * When false the hook stays false and no Script should be rendered.
 * @returns [isPaypalSdkReady, onSdkLoad] — pass onSdkLoad to <Script onLoad={...}>.
 */
export function usePaypalSdk(enabled: boolean): [boolean, () => void] {
  const [isReady, setIsReady] = useState(() => enabled && isBrowser() && !!window.paypal);

  return [isReady, () => setIsReady(true)];
}
